<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import PackagesForm from './PackagesForm';
import ServicesForm from './ServicesForm';

import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Packages & Services',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, PackagesForm, ServicesForm, CommunicationsTable },
  data() {
    return {
      title: 'Packages & Services',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Packages & Services', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,
      changes: false,

      default_new_package: {
        status: 1,
        title: '',
        sub_title:'Package',
        price: 0,
        sub_price: 'and 0% listing commission',
        ribbon_color: 'success',
        ribbon_text: 'Best value',
        upcharges: [],
        upcharges_listings: [],
        services: [],
        website: '',
      },
      new_package: {
        upcharges: [],
        upcharges_listings: [],
        services: [],
      },

      default_new_service: {
        status: 1,
        title: '',
        description: '',
        price: 0,
        additional: 1,
        once: 1,
        initial: 1,
        upgrade: 1,
        upcharges: [],
        website: '',
      },
      new_service: {
        upcharges: [],
      },

      loading: true,
      packages: [],
      services: [],
      filters: {
        paginate: 1000,
        page: 1,
        total: 0,
        wheres: {
          website: '',
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: 1,
        onable_type: 'coryallen\\Services\\Models\\Service',
      },
    }
  },
  computed: {
    activeServices: function () {
      let results = [];
      for(var i in this.packages) {
        for(var l in this.services) {
          if(l == 0) {
            results[this.packages[i].id] = [];
            results[this.packages[i].id].services = [];
          }
          var active = false;
          for(var s in this.packages[i].services) {
            if(this.packages[i].services[s].id == this.services[l].id) { active = true; }
          }
          results[this.packages[i].id].services[this.services[l].id] = active;
        }
      }
      return results;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  created() {
    this.filters.wheres.website = this.website_id;
    this.new_package = JSON.parse(JSON.stringify(this.default_new_package));
    this.new_service = JSON.parse(JSON.stringify(this.default_new_service));
    this.fetchData();
    // this.fetchServices();
  },
  methods: {
    fetchData() {
      if(!this.filters.wheres.website) { this.$noty.error('Website filter is required.'); return; }
      this.loading = true;
      this.$http.get('/api/packages/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.packages = res.data.data;

        this.$http.get('/api/services/fetch', {params: this.filters}).then(res => {
          // console.log(res);
          this.services = res.data.data;
          this.loading = false;
          this.changes = false;
        }).catch(res => { this.loading = false; this.changes = false; this.popupErrors(res); });

      }).catch(res => { this.loading = false; this.changes = false; this.popupErrors(res); });
    },
    hasService(npackage, service) {
      for(var i in npackage.services) {
        if(npackage.services[i].id == service.id){ return true; }
      }
      return false;
    },
    addToPackage(npackage, service) {
      if(this.hasService(npackage, service)) {
        for(var i in npackage.services) {
          if(npackage.services[i].id == service.id){ npackage.services.splice(i, 1); }
        }
        this.new_package = npackage;
        this.add_package(false);
      } else {
        npackage.services.push(service);
        this.new_package = npackage;
        this.add_package(false);
      }
    },
    editPackageModal(npackage) {
      this.new_package = npackage;
      if(!this.new_package.upcharges){ this.new_package.upcharges = []; }
      this.$refs.modal_add_package.show();
    },
    add_package(refresh = true) {
      // console.log(this.new_package); return;
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(this.filters.wheres.website) { this.new_package.website = this.filters.wheres.website; } else { this.$noty.warning('Error setting website ID'); return; }
      this.$http.post('/api/packages/store', this.new_package).then(res => {
        // console.log(res);
        this.new_package = JSON.parse(JSON.stringify(this.default_new_package));
        this.$refs.modal_add_package.hide();
        if(refresh) { this.fetchData(); }
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    delete_package() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.new_package.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this package?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/packages/delete/'+this.new_package.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.new_package = JSON.parse(JSON.stringify(this.default_new_package));
              this.$refs.modal_add_package.hide();
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    editServiceModal(service) {
      this.new_service = service;
      if(!this.new_service.upcharges){ this.new_service.upcharges = []; }
      this.$refs.modal_add_service.show();
    },
    add_service() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(this.filters.wheres.website) { this.new_service.website = this.filters.wheres.website; } else { this.$noty.warning('Error setting website ID'); return; }
      this.$http.post('/api/services/store', this.new_service).then(res => {
        // console.log(res);
        this.new_service = JSON.parse(JSON.stringify(this.default_new_service));
        this.$refs.modal_add_service.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    updateServiceOrder() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      this.services.map((service, index) => { service.order_id = index + 1; });
      this.$http.put('/api/services/order', {services: this.services}).then(res => {
        // console.log(res);
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });

    },
    delete_service() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.new_service.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this service?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/services/delete/'+this.new_service.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.new_service = JSON.parse(JSON.stringify(this.default_new_service));
              this.$refs.modal_add_service.hide();
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },

  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Packages & Services</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>


    <b-modal ref="modal_add_package" centered size="lg" :title="new_package.id ? 'Edit package' : 'Add new package'" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true" :no-enforce-focus="true">
      <b-form @submit.prevent="add_package">
        <div class="p-3">
          <PackagesForm :item="new_package"></PackagesForm>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button v-if="new_package.id && hasRole(['Dev','Admin'])" type="button" class="btn btn-danger mr-auto ml-0" @click="delete_package" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete</button>
          <button type="button" class="btn btn-light" @click="$refs.modal_add_package.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
        </footer>
      </b-form>
    </b-modal>

    <b-modal ref="modal_add_service" centered size="lg" :title="new_service.id ? 'Edit service' : 'Add new service'" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true" :no-enforce-focus="true">
      <b-form @submit.prevent="add_service">
        <div class="p-3">
          <ServicesForm :item="new_service"></ServicesForm>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button v-if="new_service.id && hasRole(['Dev','Admin'])" type="button" class="btn btn-danger mr-auto ml-0" @click="delete_service" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete</button>
          <button type="button" class="btn btn-light" @click="$refs.modal_add_service.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
        </footer>
      </b-form>
    </b-modal>

    <div v-show="tabIndex == 0">
      <div class="mt-4 card-box p-0 position-relative">
        <transition name="fade">
          <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
        </transition>
        <div class="px-4 pt-4 pb-3">
          <div class="row">
            <div class="col-lg-8">
              <div class="form-inline">
                <w-field class="mr-2" SimpleDataType="String List, Single" :Options="app_website_ids" v-model="filters.wheres.website" placeholder="Website..." @input="fetchData()"></w-field>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="text-lg-right mt-3 mt-lg-0">
                <button type="button" @click="new_package = JSON.parse(JSON.stringify(default_new_package)); $refs.modal_add_package.show()" class="btn btn-success ml-2" :disabled="dsbl_btn"><Icon icon="ri:add-line"></Icon> Add Package</button>
                <button type="button" @click="new_service = JSON.parse(JSON.stringify(default_new_service)); $refs.modal_add_service.show()" class="btn btn-success ml-2" :disabled="dsbl_btn"><Icon icon="ri:add-line"></Icon> Add Service</button>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-200 p-3">
          <p class="m-0">Add, edit or delete packages and services.<br>Updates will be live for visitors to see. Be sure to mark items as inactive if you would like them hidden from visitors.</p>
        </div>
        <transition name="fade">
          <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line"></Icon> commit any changes made to filters.</div>
        </transition>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive m-0">
              <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered">
                <thead>
                  <tr>
                    <th style="max-width:400px;min-width:400px;height:70px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;"></th>
                    <th style="max-width:85px;width:85px;border-width:0px;border-right-width:1px;"></th>
                    <th v-for="(item, index) in packages" :key="item.id" :class="item.status ? '' : 'bg-lighten-danger'" class="text-center text-nowrap _w-n-125">
                      <span class="_c-pointer font-weight-bold" v-tippy content="Edit package" @click="editPackageModal(item)">
                        {{item.title}} <span v-if="item.upcharges && item.upcharges.length > 0" class="text-danger" title="Upcharges">({{item.upcharges.length}})</span> <Icon icon="ri:edit-line"></Icon>
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Service Title</td>
                    <td class="font-weight-bold">Price</td>
                    <td class="font-weight-bold">Add'l</td>
                    <td class="font-weight-bold">Once</td>
                    <td class="font-weight-bold">Initial</td>
                    <td class="font-weight-bold">Upgrade</td>
                    <td class="font-weight-bold">Upcharge</td>
                    <td v-for="(item2, index) in packages" :key="item2.id" class="font-weight-bold text-center">{{formatPrice(item2.price, true, false)}}</td>
                  </tr>
                  <tr class="sticky-thead bg-white">
                    <td class="font-weight-bold">Service Title</td>
                    <td class="font-weight-bold">Price</td>
                    <td class="font-weight-bold">Add'l</td>
                    <td class="font-weight-bold">Once</td>
                    <td class="font-weight-bold">Initial</td>
                    <td class="font-weight-bold">Upgrade</td>
                    <td class="font-weight-bold">Upcharge</td>
                    <td v-for="(item2, index) in packages" :key="item2.id" class="font-weight-bold text-center">{{formatPrice(item2.price, true, false)}}</td>
                  </tr>
                </thead>
                <draggable v-model="services" :options="{animation:200}" :element="'tbody'" @change="updateServiceOrder" :disabled="dsbl_btn">
                  <tr v-for="(item, index) in services" :key="item.id">
                    <td :class="item.status ? '' : 'bg-lighten-danger'">
                      <span class="my-handle _c-pointer mr-2" v-tippy content="Drag to arrange"><Icon icon="ri:menu-line"></Icon></span>
                      <span class="_c-pointer font-weight-bold" v-tippy content="Edit service" @click="editServiceModal(item)">
                        {{item.title}} <Icon icon="ri:edit-line"></Icon>
                      </span>
                    </td>
                    <td :class="item.price > 0 ? 'bg-lighten-success': 'bg-lighten-danger'">{{formatPrice(item.price)}}</td>
                    <td :class="item.additional == 1 ? 'bg-lighten-success': 'bg-lighten-danger'">{{item.additional == 1 ? 'Yes': 'No'}}</td>
                    <td :class="item.once == 1 ? 'bg-lighten-success': 'bg-lighten-danger'">{{item.once == 1 ? 'Yes': 'No'}}</td>
                    <td :class="item.initial == 1 ? 'bg-lighten-success': 'bg-lighten-danger'">{{item.initial == 1 ? 'Yes': 'No'}}</td>
                    <td :class="item.upgrade == 1 ? 'bg-lighten-success': 'bg-lighten-danger'">{{item.upgrade == 1 ? 'Yes': 'No'}}</td>
                    <td :class="item.upcharges && item.upcharges.length > 0 ? 'bg-lighten-success': 'bg-lighten-danger'">{{item.upcharges && item.upcharges.length > 0 ? 'Yes': 'No'}}</td>
                    <td v-for="(item2, index2) in packages" :key="'b'+index2" class="text-center">
                      <w-field SimpleDataType="Boolean" v-model="activeServices[item2.id].services[item.id]" Color="success" @input="addToPackage(item2,item)" class="m-0" trueValue="" :Disabled="dsbl_btn"></w-field>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-show="tabIndex == 1">
      <div class="mt-4">
        <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
      </div>
    </div>


  </Layout>
</template>
